import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link, Text, InternalGrid, SkeletonItem } from '@paygreen/paygreen-ui';
import {
    getDataFromObject,
    fixExternalUrl,
    shortExternalUrl,
    IsMobile,
    truncateTooLongName,
} from '../../../../utils/tools';
import { visibilityStatus } from '../../../../utils/constants';
import {
    LineKeyValue,
    CardClassic,
    ErrorBoundary,
    StatusDisplayTable,
} from '../../../../components';
import UploadLogo from '../../../user/charity/UploadLogo';
import {
    charityManagementList,
    EditModalIcon,
    visibilityStatusOptions,
} from '../../shared';
import CharityManagementModal from './CharityManagementModal';

const CharityManagementCard = ({
    t,
    isLoading,
    setIsLoading,
    accountData,
    setAccountData,
    refresh,
}) => {
    const handleUpdate = (data) => {
        setAccountData({
            ...accountData,
            association: data,
        });
    };

    return (
        <ErrorBoundary>
            <SkeletonItem
                blockHeight="auto"
                colorWab="grey10"
                radiusSize="sm"
                isLoading={isLoading}
            >
                <CardClassic
                    isLoading={isLoading}
                    title={t('charity.charityAdminCard')}
                    titleSize="md"
                    actionIcon={
                        <EditModalIcon title={t('admin.charity.editCharity')}>
                            <CharityManagementModal
                                accountData={accountData}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                setAccountData={setAccountData}
                                isShop={false}
                                refresh={refresh}
                            />
                        </EditModalIcon>
                    }
                    isShadowWab={true}
                >
                    <InternalGrid
                        displayType="grid"
                        gridTemplateColumns="1fr auto"
                        gridGap="md"
                        hasStaticWidth={true}
                        justifyItems="start"
                    >
                        <InternalGrid
                            displayType="grid"
                            gridTemplateColumns={
                                IsMobile() ? '1fr' : 'auto auto'
                            }
                            justifyItems="stretch"
                            alignItems="baseline"
                            gridGap="md"
                            childrenMarginTop="none"
                            childrenMarginBottom="none"
                        >
                            {charityManagementList.map((item, index) => {
                                const { name, value, type } = item;

                                return (
                                    <LineKeyValue
                                        key={index}
                                        hasUppercase={false}
                                        keyLabel={t(
                                            'admin.charity.charityInfos.' +
                                                name +
                                                'Input',
                                        )}
                                        keyValue={
                                            accountData &&
                                            truncateTooLongName(
                                                type === 'fieldOfAction'
                                                    ? t(
                                                          `charity.edit.fieldOfActionValues.${getDataFromObject(
                                                              value,
                                                              accountData,
                                                          )}`,
                                                      )
                                                    : getDataFromObject(
                                                          value,
                                                          accountData,
                                                      ),
                                                150,
                                            )
                                        }
                                        textSize="xs"
                                    >
                                        {type === 'link' ? (
                                            <a
                                                href={fixExternalUrl(
                                                    getDataFromObject(
                                                        value,
                                                        accountData,
                                                    ),
                                                )}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Text textSize="xs">
                                                    <Link colorTheme="secondary">
                                                        {truncateTooLongName(
                                                            shortExternalUrl(
                                                                getDataFromObject(
                                                                    value,
                                                                    accountData,
                                                                ),
                                                            ),
                                                            25,
                                                        )}
                                                    </Link>
                                                </Text>
                                            </a>
                                        ) : type === 'status' ? (
                                            <StatusDisplayTable
                                                style={{ alignSelf: 'center' }}
                                                status={
                                                    getDataFromObject(
                                                        value,
                                                        accountData,
                                                    ) === "1"
                                                        ? visibilityStatus.VISIBLE
                                                        : visibilityStatus.NOTVISIBLE
                                                }
                                                statusOptions={
                                                    visibilityStatusOptions
                                                }
                                                i18TextBase="admin.charities.table.visibilityStatusFilter"
                                            />
                                        ) : null}
                                    </LineKeyValue>
                                );
                            })}
                        </InternalGrid>

                        <UploadLogo
                            charityDataLocal={accountData?.association}
                            isLoading={isLoading}
                            updateData={handleUpdate}
                        />
                    </InternalGrid>
                </CardClassic>
            </SkeletonItem>
        </ErrorBoundary>
    );
};

CharityManagementCard.propTypes = {
    isLoading: PropTypes.bool,
    accountData: PropTypes.object,
    refresh: PropTypes.func,
};

CharityManagementCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(CharityManagementCard);
